var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", md8: "", "offset-md1": "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    [
                      _c("h4", [_vm._v("Free Samples")]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            color: "primary",
                            loading: _vm.freeSamplesLoading,
                            disabled: _vm.freeSamplesLoading,
                            fab: "",
                            flat: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.searchFreeSamples()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("refresh")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-data-table",
                        {
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.orders,
                            loading: _vm.freeSamplesLoading,
                            pagination: _vm.pagination,
                            "total-items": _vm.totalFreeSamples,
                            "rows-per-page-items": _vm.rowsPerPageItems
                          },
                          on: {
                            "update:pagination": function($event) {
                              _vm.pagination = $event
                            }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c("td", [
                                    _vm._v(_vm._s(props.item.orderCode) + " "),
                                    props.item.status === "Cart"
                                      ? _c("span", [
                                          _vm._v(
                                            "(" +
                                              _vm._s(props.item.status) +
                                              ")"
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  props.item.customerID
                                    ? _c(
                                        "td",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                flat: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onClickingCustomerName(
                                                    props.item._id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  props.item.customerID
                                                    ? props.item.customerID
                                                        .firstName +
                                                        " " +
                                                        props.item.customerID
                                                          .lastName
                                                    : ""
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c("td"),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(props.item.freeSamples[0]))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        new Date(props.item.date).getDate() +
                                          "/" +
                                          (new Date(
                                            props.item.date
                                          ).getMonth() +
                                            1) +
                                          "/" +
                                          new Date(
                                            props.item.date
                                          ).getFullYear()
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  props.item.status == "Sent to Customer"
                                    ? _c("td", [_vm._v("Yes")])
                                    : _c("td", [_vm._v("No")]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: [
                                            {
                                              text: "Edit",
                                              value: {
                                                action: "edit",
                                                id: props.item._id
                                              }
                                            },
                                            {
                                              text: "Email Confirmation",
                                              value: {
                                                action: "email",
                                                id: props.item._id
                                              }
                                            },
                                            {
                                              text: "Delete",
                                              value: {
                                                action: "delete",
                                                id: props.item._id
                                              }
                                            }
                                          ],
                                          label: "Actions"
                                        },
                                        on: { change: _vm.freeSampleActions }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c("v-progress-linear", {
                            attrs: {
                              slot: "progress",
                              color: "primary",
                              indeterminate: ""
                            },
                            slot: "progress"
                          }),
                          _vm._v(" "),
                          _vm._v(" "),
                          _c("template", { slot: "no-data" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.loadingText) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("template", { slot: "no-results" }, [
                            _vm._v(
                              "\n              Your search for '" +
                                _vm._s(_vm.search) +
                                "' didn't return any results.\n            "
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", md2: "" } },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_c("h4", [_vm._v("Search and Filter")])]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "search",
                          label: "Search",
                          "single-line": "",
                          "hide-details": ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.searchFreeSamples()
                          }
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-spacer", { staticClass: "v-text-field" }),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              _vm.oldOrdersDialog = true
                            }
                          }
                        },
                        [_vm._v("Show Old Orders")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { dark: "", top: "", timeout: 3000 },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.oldOrdersDialog,
            callback: function($$v) {
              _vm.oldOrdersDialog = $$v
            },
            expression: "oldOrdersDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("h2", [_vm._v("Search Old Free Sample Orders")])
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "search",
                      label: "Search",
                      "single-line": "",
                      "hide-details": ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.searchSentFreeSamples()
                      }
                    },
                    model: {
                      value: _vm.searchSent,
                      callback: function($$v) {
                        _vm.searchSent = $$v
                      },
                      expression: "searchSent"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _vm.sentOrders.length
                    ? _c(
                        "table",
                        { staticClass: "mt-4", attrs: { width: "100%" } },
                        [
                          _c("tr", { staticClass: "text-xs-center" }, [
                            _c("th", [_vm._v("Order Code")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Name")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Samples")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Date")])
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.sentOrders, function(order, index) {
                            return _c(
                              "tr",
                              { key: index, staticClass: "text-xs-center" },
                              [
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          flat: "",
                                          color: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.$router.push({
                                              path:
                                                "/freeSampleOrder/" + order._id
                                            })
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(order.orderCode))]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                order.customerID
                                  ? _c(
                                      "td",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              small: "",
                                              flat: "",
                                              color: "primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onClickingCustomerNameSent(
                                                  order._id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                order.customerID
                                                  ? order.customerID.firstName +
                                                      " " +
                                                      order.customerID.lastName
                                                  : ""
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _c("td"),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(order.freeSamples[0]))
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      new Date(order.date).getDate() +
                                        "/" +
                                        (new Date(order.date).getMonth() + 1) +
                                        "/" +
                                        new Date(order.date).getFullYear()
                                    )
                                  )
                                ])
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: {
                        click: function($event) {
                          _vm.oldOrdersDialog = false
                        }
                      }
                    },
                    [_vm._v("Close")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.freeSampleCustomerDialog,
            callback: function($$v) {
              _vm.freeSampleCustomerDialog = $$v
            },
            expression: "freeSampleCustomerDialog"
          }
        },
        [
          _vm.selectedOrder
            ? _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(
                      _vm._s(_vm.selectedOrder.orderCode) +
                        " - Customer Details"
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c("p", [
                      _vm._v(
                        "Name: " +
                          _vm._s(_vm.selectedOrder.customerID.firstName) +
                          " " +
                          _vm._s(_vm.selectedOrder.customerID.lastName)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Phone: " + _vm._s(_vm.selectedOrder.customerID.phone)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Email: " + _vm._s(_vm.selectedOrder.customerID.email)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", flat: "" },
                          on: {
                            click: function($event) {
                              _vm.freeSampleCustomerDialog = false
                            }
                          }
                        },
                        [_vm._v("Close")]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            flat: "",
                            target: "_blank",
                            to: "/customers/" + _vm.selectedOrder.customerID._id
                          }
                        },
                        [_vm._v("Go to Customer")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-578c252a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-578c252a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/freeSamples/FreeSamples.vue
// module id = null
// module chunks = 